
<script>
import router from "../../router";
import Multiselect from "vue-multiselect";
import Vue from "vue";
import Alert from "@/components/Alert";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: "AddItem",
  components: {
    Multiselect,
    Alert,
    Treeselect
  },
  data() {
    return {
      accessRight: {},
      filteredStore: [],
      filteredVariant: [],
      is_menu_app: false,
      is_enable_b2b: false,
      stores: [],
      isAll: false,
      item: {
        description: "",
        category_id: "",
        sold_by: "EACH",
        variants_combinations: [],
        representation_type: "COLOR",
        available: true,
        force_allow_none_store: false,
      },
      color_list: [],
      suppliers: [],
      categories: [],
      item_list: [],
      selected_item: { name: "" },
      selected_items: [],
      selected_taxes: [],
      modifiers: [],
      selected_modifiers: [],
      taxes: [],
      item_variant_stores: [],
      item_variant_stores_all: [],
      sku: null,
      variants: [
        {
          name: "",
          options: []
        }
      ],
      show_variants: [
        {
          name: "",
          options: []
        }
      ],
      prev_varinat_map: null,
      variant_options_map: null,
      prev_variant_store_map: null,
      variant_store_map: null,
      prev_price: null,
      selectedStores: [],
      filterObj: {
        store: "",
        variant: ""
      }
    };
  },
  methods: {
    saveNoneItemStore(e){
      this.item.force_allow_none_store = true
      this.$refs.noneItemStore.close();
      this.save()
    },
    normalizerVariant(node) {
      return {
        id: node.name,
        label: node.name,
      }
    },
    normalizerStore(node) {
      return {
        id: node.id,
        label: node.name,
      }
    },
    limitStoreText(count){
      return `${count} ${this.$lang.messages.stores}`
    },
    limitVariantText(count){
      return `${count} ${this.$lang.messages.variants}`
    },
    onSupplierSelect(option) {
      if (option) {
        this.item.primary_supplier = option.id;
      }
    },
    setSupplierName({ name }) {
      return name;
    },
    calculateCompositeItemPrice(index) {
      if (
        this.selected_items[index].cost != null &&
        this.selected_items[index].cost > 0 &&
        this.selected_items[index].quantity != null &&
        this.selected_items[index].quantity > 0
      ) {
        this.selected_items[index].price =
          this.selected_items[index].quantity * this.selected_items[index].cost;
        this.$set(this.selected_items, index, this.selected_items[index]);
      }
    },
    changeRate() {
      for (var x7 = 0; x7 < this.item_variant_stores.length; x7++) {
        if (
          this.item_variant_stores[x7].price == null ||
          !this.item_variant_stores[x7].price ||
          this.item_variant_stores[x7].price == this.prev_price
        ) {
          this.item_variant_stores[x7].price = this.item.price;
          this.$set(this.item_variant_stores, x7, this.item_variant_stores[x7]);
        }
      }
      this.prev_price = this.item.price;
    },
    changeIsCompositeItem(event) {
      if (event.target.checked) {
        this.item.cost = null;
        this.selected_items = [];
        this.selectedStores = [];
        this.item_variant_stores = [];
        this.item_variant_stores_all = [];
        for (var i = 0; i < this.stores.length; i++) {
          var obj = {
            store_id: this.stores[i].id,
            name: this.stores[i].name,
            is_available: true,
            cost_editable: true,
            in_stock_editable: true
          };
          this.item_variant_stores.push(obj);
          this.item_variant_stores_all.push(obj);
        }

        this.isAll = true;
        this.checkAllStores();
      }
    },
    checkAllStores(event) {
      this.selectedStores = [];
      if (this.isAll) {
        for (var i = 0; i < this.item_variant_stores.length; i++) {
          if (
            this.item.variants_combinations != null &&
            this.item.variants_combinations.length > 0
          ) {
            this.selectedStores.push(
              this.item_variant_stores[i].store_id +
                "_" +
                this.item_variant_stores[i].value
            );
          } else {
            this.selectedStores.push(this.item_variant_stores[i].store_id);
          }
        }
      }
    },

    setAvailableStr() {
      if (this.selectedStores.length > 0) {
        this.isAll =
          this.selectedStores.length == this.item_variant_stores.length;
      }
    },
    checkUncheckStore(event, index) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
        this.item_variant_stores[index].is_available = false;

        this.$set(
          this.item_variant_stores,
          index,
          this.item_variant_stores[index]
        );
      } else {
        this.item_variant_stores[index].is_available = true;

        this.$set(
          this.item_variant_stores,
          index,
          this.item_variant_stores[index]
        );
      }
    },
    getStores() {
      this.stores = [];
      this.item_variant_stores = [];
      this.item_variant_stores_all = [];
      return this.$api
        .getAPI({
          _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.stores = res.list;
          if (!this.item.id) {
            for (var i = 0; i < this.stores.length; i++) {
              var obj = {
                store_id: this.stores[i].id,
                name: this.stores[i].name,
                is_available: true,
                cost_editable: true,
                in_stock_editable: true
              };
              this.item_variant_stores.push(obj);
              this.item_variant_stores_all.push(obj);
            }

            this.isAll = true;
            this.checkAllStores();
          }
        });
    },

    getSuppliers() {
      this.suppliers = [];

      return this.$api
        .getAPI({
          _action: "/supplier/list"
        })
        .then(res => {
          this.suppliers = res.list;
        });
    },

    getNextSKU() {
      this.taxes = [];
      return this.$api
        .getAPI({
          _action: "/item/next_sku"
        })
        .then(res => {
          this.sku = res.next_sku.toString();
          this.item.sku = res.next_sku.toString();
        });
    },
    selectColorCode(id) {
      this.item.representation_color = id;
      $("li.color-thumb").removeClass("active");
      $("#color_" + id).addClass("active");
    },
    selectShape(shape, id) {
      this.item.representation_shape = shape;
      $("li.shape-thumb").removeClass("active");
      $("#" + id).addClass("active");
    },
    getColorList() {
      this.$api
        .getAPI({ _action: "/color/list" })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.color_list = res.list;
            if (this.item.id) {
              setTimeout(() => {
                this.selectColorCode(this.color_list[0].id);
              }, 200);
            }
          }
          this.selectShape("RECTANGLE", "RECTANGLE");
        })
        .catch(e => {});
    },
    resetAddVariantModal() {},
    clearAddVariantModal() {
      if (this.variants.length < 1) {
        this.variants = [...[]]
        this.show_variants = [...[]]
        this.addVariantOption();
      }

      this.show_variants = [];
      for (var i = 0; i < this.variants.length; i++) {
        var variantOption = {
          name: this.variants[i].name
        };
        var options = [];
        for (var z = 0; z < this.variants[i].options.length; z++) {
          options.push(this.variants[i].options[z]);
        }
        variantOption.options = options;
        this.show_variants.push(variantOption);
      }

      this.errors.clear("add-variant-form");
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (scope == "main-form") {
            this.save();
          }
          if (scope == "add-variant-form") {
            this.assignVariants();
          } else if (scope == "variants-combinations-form") {
          }
          return;
        }
      });
    },
    clearForm(scope) {
      this.$validator(scope).then(result => {
        if (result) {
          if (scope == "main-form") {
            this.save();
          } else if (scope == "add-variant-form") {
            this.createCombination();
          } else if (scope == "variants-combinations-form") {
          }
          return;
        }
      });
    },
    onChangeFilter(e) {
      var vm = this;
      $("#store_table tr")
        .filter(function() {
          var variants_combination_name = $(this)
            .find("td.variants_combination_name")
            .first()
            .text();
          var store_name = $(this)
            .find("td.store_name")
            .first()
            .text();
          return !(
            (vm.filterObj.store == "" || vm.filterObj.store == store_name) &&
            (vm.filterObj.variant == "" ||
              vm.filterObj.variant == variants_combination_name)
          );
        })
        .hide();
      $("#store_table tr")
        .filter(function() {
          var variants_combination_name = $(this)
            .find("td.variants_combination_name")
            .first()
            .text();
          var store_name = $(this)
            .find("td.store_name")
            .first()
            .text();
          return (
            (vm.filterObj.store == "" || vm.filterObj.store == store_name) &&
            (vm.filterObj.variant == "" ||
              vm.filterObj.variant == variants_combination_name)
          );
        })
        .show();
    },
    onChangeCategory(e) {
      if (e.target.value == "") {
        this.item_variant_stores = this.item_variant_stores_all;
      } else {
        var selected_category = this.categories.find(category => {
          return category.id == e.target.value;
        });
        var category_stores = selected_category.stores.map(category_store => {
          return category_store.store_id;
        });
        this.item_variant_stores = this.item_variant_stores_all.filter(
          item_variant_store => {
            return category_stores.includes(item_variant_store.store_id);
          }
        );
      }
    },
    onChangeItemPrice(e) {
      if (this.item_variant_stores != null) {
        for (var i = 0; i < this.item_variant_stores.length; i++) {
          this.item_variant_stores[i].price = e.target.value;
          Vue.set(this.item_variant_stores, i, this.item_variant_stores[i]);
        }
      }
    },
    onChangeItemCost(e) {
      if (this.item_variant_stores != null) {
        for (var i = 0; i < this.item_variant_stores.length; i++) {
          this.item_variant_stores[i].cost = e.target.value;
          Vue.set(this.item_variant_stores, i, this.item_variant_stores[i]);
        }
      }
    },
    onChangeVariantPrice(e) {
      if (this.item_variant_stores != null) {
        for (var i = 0; i < this.item_variant_stores.length; i++) {
          if (
            this.item_variant_stores[i].value ==
            $(e.target)
              .closest("tr")
              .find("td")
              .first()
              .text()
          ) {
            this.item_variant_stores[i].price = e.target.value;
            Vue.set(this.item_variant_stores, i, this.item_variant_stores[i]);
          }
        }
      }
    },
    onChangeVariantCost(e) {
      if (this.item_variant_stores != null) {
        for (var i = 0; i < this.item_variant_stores.length; i++) {
          if (
            this.item_variant_stores[i].value == $(e.target).closest("tr").find("td").first().text()
          ) {
            this.item_variant_stores[i].cost = e.target.value;
            Vue.set(this.item_variant_stores, i, this.item_variant_stores[i]);
          }
        }
      }
    },

    onChange(e) {
      let files = e.target.files;
      this.file = files[0];

      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
          $("#img_hoder_1").attr("src", e.target.result);
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    },
    uploadFile(id) {
      this.$api
        .uploadImageAPI({
          _action: "/item/image/" + id,
          _key: "representation_image",
          _file: this.file
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          router.push("/items");
        });
    },
    save() {
      if (!this.item.price) {
        this.item.price = 0;
      }
      if (!this.item.cost) {
        this.item.cost = 0;
      }
      if (
        this.item_variant_stores != null &&
        this.item_variant_stores.length > 0
      ) {
        this.item.stores = this.item_variant_stores;
      }
      var tempSelectedStoreSet = new Set(this.selectedStores);
      for (var s = 0; s < this.item.stores.length; s++) {
        if (
          this.item.variants_combinations != null &&
          this.item.variants_combinations.length > 0
        ) {
          if (
            !tempSelectedStoreSet.has(
              this.item.stores[s].store_id + "_" + this.item.stores[s].value
            )
          ) {
            this.item.stores[s].is_available = false;
          } else {
            this.item.stores[s].is_available = true;
          }
        } else {
          if (!tempSelectedStoreSet.has(this.item.stores[s].store_id)) {
            this.item.stores[s].is_available = false;
          } else {
            this.item.stores[s].is_available = true;
          }
        }
        this.$set(this.item.stores, s, this.item.stores[s]);
      }

      if (this.variants != null && this.variants.length > 0) {
        this.item.variants = this.variants;
      }
      this.item.modifiers = this.selected_modifiers;
      this.item.taxes = this.selected_taxes;

      if (this.item.representation_type == "IMAGE") {
        if (!this.file && !this.item.representation_image) {
          this.$notify({
            group: "foo",
            text: this.$lang.messages.please_select_image,
            type: "error"
          });
          return false;
        }
      }

      if (
        this.item.variants &&
        this.item.variants.length == 1 &&
        this.item.variants[0].name == ""
      ) {
        this.item.variants = [];
      }
      this.item.item_composites = this.selected_items;

      if (!this.item.representation_color) {
        this.item.representation_color = this.color_list[0].id;
      }

      if(this.item.variants_combinations.length > 0){
          // Filter and fill item store without variant
          for(var k=0; k<this.item.variants_combinations.length; k++){
              const variant_value = this.item.variants_combinations[k].value;
              for(var i=0; i<this.item.stores.length; i++){
                  if(!this.item.stores[i].value){
                      this.item.stores[i].value = variant_value
                  }
              }
          }
      }

      if (this.item.id) {
        this.$api
          .putAPI({
            _action: "/item/update",
            _body: this.item,
            _buttonId: "save-btn"
          })
          .then(res => {
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            if (this.item.representation_type == "IMAGE" && this.file) {
              this.uploadFile(this.item.id);
            } else {
              router.push("/items");
            }
          })
          .catch(e => {
            if (e.status == 409){
              this.$refs.duplicatedItemAlert.message = this.$lang.messages.similar_item_name_already_exists;
              $('#duplicated-name-modal').modal('show');
            }
            if (e.status == 406){
              this.$refs.noneItemStore.message = e.data.message;
              $('#none-item-store-modal').modal('show');
            }
          });
      } else {
        this.$api
          .postAPI({
            _action: "/item/save",
            _body: this.item,
            _buttonId: "save-btn"
          })
          .then(res => {
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            if (this.item.representation_type == "IMAGE" && this.file) {
              this.uploadFile(res.id);
            } else {
              router.push("/items");
            }
          })
          .catch(e => {
            if (e.status == 409){
              this.$refs.duplicatedItemAlert.message = this.$lang.messages.similar_item_name_already_exists;
              $('#duplicated-name-modal').modal('show');
            }
            if (e.status == 406){
              this.$refs.noneItemStore.message = e.data.message;
              $('#none-item-store-modal').modal('show');
            }
          });
      }
    },
    saveDuplicatedName(e){
      this.item.ignore_duplicated_name = true;
      this.$refs.duplicatedItemAlert.close();
      this.save();
    },
    assignVariants() {
      this.variants = [];

      for (var i = 0; i < this.show_variants.length; i++) {
        var variantOption = {
          name: this.show_variants[i].name
        };
        var options = [];
        for (var z = 0; z < this.show_variants[i].options.length; z++) {
          options.push(this.show_variants[i].options[z]);
        }
        variantOption.options = options;
        this.variants.push(variantOption);
      }
      this.createCombination();

      if(this.item.category_id && this.item.category_id){
        this.onChangeCategory({target: {value: this.item.category_id}})
      }
    },
    createCombination() {
      var variantTitleNameList = [];
      if (this.variants != null && this.variants.length > 0) {
        var variantList = this.variants;

        var variantList1 = variantList[0].options;

        if (variantList1 != null && variantList1.length > 0) {
          for (var i = 0; i < variantList1.length; i++) {
            var value = variantList1[i];
            if (variantList.length >= 2) {
              var variantList2 = variantList[1].options;
              if (variantList2 != null && variantList2.length > 0) {
                for (var j = 0; j < variantList2.length; j++) {
                  if (variantList.length == 3) {
                    value = variantList1[i] + "/" + variantList2[j];
                    var variantList3 = variantList[2].options;
                    if (variantList3 != null && variantList3.length > 0) {
                      for (var k = 0; k < variantList3.length; k++) {
                        variantTitleNameList.push(
                          value + "/" + variantList3[k]
                        );
                      }
                    }
                  } else {
                    variantTitleNameList.push(value + "/" + variantList2[j]);
                  }
                }
              }
            } else {
              variantTitleNameList.push(value);
            }
          }
        }
      }
      this.item.variants_combinations = [];
      this.item_variant_stores = [];
      this.item_variant_stores_all = [];
      var skuSet = new Set();
      if (variantTitleNameList != null && variantTitleNameList.length > 0) {
        var variant_sku = this.sku;

        for (var x = 0; x < variantTitleNameList.length; x++) {
          var combination = {
            name: variantTitleNameList[x],
            price: this.item.price,
            cost: this.item.cost
          };
          if (this.prev_varinat_map.has(variantTitleNameList[x])) {
            combination = this.prev_varinat_map.get(variantTitleNameList[x]);
          }

          if (!combination.sku) {
            var isSkuAvailable = true;
            while (isSkuAvailable) {
              if (skuSet.has(variant_sku)) {
                variant_sku = parseInt(variant_sku) + 1 || variant_sku;
              } else {
                isSkuAvailable = false;
              }
            }
            combination.sku = variant_sku;

            skuSet.add(variant_sku);
          } else {
            skuSet.add(combination.sku);
          }
          this.variant_options_map.set(variantTitleNameList[x], combination);
          this.item.variants_combinations.push(combination);
        }
        this.prev_varinat_map = this.variant_options_map;
      } else {
        this.variant_options_map.clear();
        this.prev_varinat_map.clear();
        this.variant_store_map.clear();
        this.prev_variant_store_map.clear();
      }
      var tempSelectedStoreSet = new Set();

      for (var t = 0; t < this.stores.length; t++) {
        if (
          this.item.variants_combinations != null &&
          this.item.variants_combinations.length > 0
        ) {
          for (var w = 0; w < this.item.variants_combinations.length; w++) {
            var store_obj = {
              name: this.stores[t].name,
              store_id: this.stores[t].id,
              value: this.item.variants_combinations[w].name,
              is_available: true,
              price: this.item.price ? this.item.price : null,
              cost: this.item.cost ? this.item.cost : null,
              cost_editable: true,
              in_stock_editable: true
            };
            if (
              this.prev_variant_store_map != null &&
              this.prev_variant_store_map.has(
                this.stores[t].id +
                  "_" +
                  this.item.variants_combinations[w].name
              )
            ) {
              var prev_obj = this.prev_variant_store_map.get(
                this.stores[t].id +
                  "_" +
                  this.item.variants_combinations[w].name
              );
              if (prev_obj) {
                store_obj = prev_obj;
                store_obj.is_available =
                  prev_obj.is_available != null ? prev_obj.is_available : true;
              } else {
                store_obj.price = this.item.price;
                store_obj.cost = this.item.cost;
                store_obj.is_available = true;
              }
            }
            if (store_obj.is_available) {
              tempSelectedStoreSet.add(
                this.stores[t].id +
                  "_" +
                  this.item.variants_combinations[w].name
              );
            }
            this.variant_store_map.set(
              this.stores[t].id + "_" + this.item.variants_combinations[w].name,
              store_obj
            );
            store_obj.store_id = this.stores[t].id;
            this.item_variant_stores.push(store_obj);
            this.item_variant_stores_all.push(store_obj);
          }
          this.prev_variant_store_map = this.variant_store_map;
        } else {
          var store_obj1 = {
            name: this.stores[t].name,
            store_id: this.stores[t].id,
            is_available: true
          };
          this.item_variant_stores.push(store_obj1);
          this.item_variant_stores_all.push(store_obj1);

          tempSelectedStoreSet.add(this.stores[t].id);
        }
      }

      this.selectedStores = Array.from(tempSelectedStoreSet);

      if (this.selectedStores.length == this.item_variant_stores.length) {
        this.isAll = true;
        this.checkAllStores();
      } else {
        this.isAll = false;
      }

      this.setAvailableStr();

      this.$refs.addVariantCloseBtn.click();
    },
    addTag(newTag, id) {
      var index = id.replace("option_", "");
      index = Number(index);
      const tag = newTag;
      this.show_variants[index].options.push(tag);
    },

    details(id) {
      this.item = {};
      this.variant_store_map = new Map();
      this.prev_variant_store_map = new Map();

      this.$api
        .getAPI({
          _action: "/item/get/" + id
        })
        .then(res => {
          this.item = res;

          if (res.representation_color) {
            setTimeout(() => {
              this.selectColorCode(res.representation_color);
            }, 1000);
          }

          if (res.categories != null && res.categories.length > 0) {
            this.item.category_id = res.categories[0].id;
          } else {
            this.item.category_id = "";
          }
          this.item_variant_stores = res.stores;
          this.categories = this.categories.filter((category) => {
            return category.stores.map(store => store.store_id).some(
                category_store => this.item_variant_stores.map(
                  item_variant_store => item_variant_store.store_id
                ).includes(category_store)
              );
          });
          this.item_variant_stores_all = this.item_variant_stores;
          this.selectedStores = [];

          if (res.primary_supplier != null && res.primary_supplier.length > 0) {
            for (var c5 = 0; c5 < this.suppliers.length; c5++) {
              if (this.suppliers[c5].id == res.primary_supplier) {
                this.item.primary_supplier_object = this.suppliers[c5];
                break;
              }
            }
          }

          for (var c1 = 0; c1 < this.item_variant_stores.length; c1++) {
            if (this.item_variant_stores[c1].is_available) {
              if (this.item_variant_stores[c1].item_variant_combination_id) {
                this.selectedStores.push(
                  this.item_variant_stores[c1].store_id +
                    "_" +
                    this.item_variant_stores[c1].value
                );

                this.variant_store_map.set(
                  this.item_variant_stores[c1].store_id +
                    "_" +
                    this.item_variant_stores[c1].value,
                  this.item_variant_stores[c1]
                );
              } else {
                this.selectedStores.push(this.item_variant_stores[c1].store_id);
                this.variant_store_map.set(
                  this.item_variant_stores[c1].store_id,
                  this.item_variant_stores[c1]
                );
              }
            }
          }

          this.prev_variant_store_map = this.variant_store_map;

          if (this.item_variant_stores.length == this.selectedStores.length) {
            this.isAll = true;
          } else {
            this.isAll = false;
          }

          this.setAvailableStr();

          this.selected_modifiers = [];
          this.selected_taxes = [];
          if (res.modifiers != null && res.modifiers.length > 0) {
            for (var c2 = 0; c2 < res.modifiers.length; c2++) {
              this.selected_modifiers.push(res.modifiers[c2].modifier_id);
            }
          }

          if (
            this.item.variants_combinations != null &&
            this.item.variants_combinations.length > 0
          ) {
            for (
              var c4 = 0;
              c4 < this.item.variants_combinations.length;
              c4++
            ) {
              this.item.variants_combinations[c4].cost_saved =
                this.item.variants_combinations[c4].cost != "";
              this.variant_options_map.set(
                this.item.variants_combinations[c4].name,
                this.item.variants_combinations[c4]
              );
            }
          }

          this.prev_varinat_map = this.variant_options_map;
          if (res.taxes != null && res.taxes.length > 0) {
            for (var c3 = 0; c3 < res.taxes.length; c3++) {
              this.selected_taxes.push(res.taxes[c3].tax_id);
            }
          }

          this.variants = res.variants;
          this.show_variants = res.variants;
          this.selected_items = res.item_composites;

          if (
            res.representation_shape != null &&
            res.representation_shape.length > 0
          ) {
            setTimeout(() => {
              this.selectShape(
                res.representation_shape,
                res.representation_shape
              );
            }, 200);
          }
        });
      this.getColorList();
    },
    getAllCategoryList() {
      return this.$api
        .getAPI({
          _action: `/category/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}&items=0`,
        })
        .then(res => {
          this.categories = res.list;
        });
    },
    nameWithLang({ name }) {
      return `${name}`;
    },
    removeSelectedItem(index) {
      this.selected_items.splice(index, 1);
    },
    removeVariant(index) {
      this.show_variants.splice(index, 1);
      this.variants.splice(index, 1);
    },
    removeItemVariantCombination(index) {
      var removeOptionIndexSet = [];

      var store_id = this.item.variants_combinations[index].store_id;
      var name = this.item.variants_combinations[index].name;
      if (this.variant_options_map.has(name)) {
        this.variant_options_map.delete(name);
      }

      this.item.variants_combinations.splice(index, 1);

      this.item_variant_stores = [];
      this.item_variant_stores_all = [];

      var temp_variant_store_map = new Map();
      var me = this;
      var tempSelectedStoreSet = new Set(this.selectedStores);

      this.variant_store_map.forEach(function(value, key, map) {
        if (!key.includes(name)) {
          temp_variant_store_map.set(key, value);
          me.item_variant_stores.push(value);
          me.item_variant_stores_all.push(value);
        } else {
          if (tempSelectedStoreSet.has(key)) {
            tempSelectedStoreSet.delete(key);
          }
        }
      });

      this.selectedStores = Array.from(tempSelectedStoreSet);
      this.variant_store_map = temp_variant_store_map;

      if (this.item_variant_stores.length < 1) {
        this.selectedStores = [];
        for (var i = 0; i < this.stores.length; i++) {
          var obj = {
            store_id: this.stores[i].id,
            name: this.stores[i].name,
            is_available: true
          };
          this.item_variant_stores.push(obj);
          this.item_variant_stores_all.push(obj);
        }

        this.isAll = true;
        this.checkAllStores();
      } else {
        if (this.selectedStores.length == this.item_variant_stores.length) {
          this.isAll = true;
          this.checkAllStores();
        }
      }

      if (this.show_variants != null && this.show_variants.length > 0) {
        for (var x4 = 0; x4 < this.show_variants.length; x4++) {
          var optionArr = [];
          var isOptionExist = false;
          for (var x2 = 0; x2 < this.show_variants[x4].options.length; x2++) {
            isOptionExist = false;

            var me = this;
            this.variant_options_map.forEach(function(value, key, map) {
              if (key.includes(me.show_variants[x4].options[x2])) {
                isOptionExist = true;
                return false;
              }
            });
            if (isOptionExist) {
              optionArr.push(this.show_variants[x4].options[x2]);
            }
          }
          this.show_variants[x4].options = optionArr;
          this.variants[x4].options = optionArr;
          var test_obj = this.variants[x4];
          test_obj.options = optionArr;
          if (optionArr.length < 1) {
            removeOptionIndexSet.push(x4);
          }
          this.$set(this.show_variants, x4, this.show_variants[x4]);
        }
      }

      if (
        removeOptionIndexSet &&
        removeOptionIndexSet != null &&
        removeOptionIndexSet.length > 0
      ) {
        for (var x5 = 0; x5 < removeOptionIndexSet.length; x5++) {
          this.removeVariant(removeOptionIndexSet[x5]);
        }
      }

      if (
        this.item.variants_combinations == null ||
        this.item.variants_combinations.length < 1
      ) {
        this.variants.splice(0, this.variants.length);
        this.show_variants.splice(0, this.show_variants.length);
      }
    },
    addVariantOption() {
      var variantOption = {
        name: "",
        options: []
      };
      this.show_variants.push(variantOption);
      this.variants.push(variantOption);
    },
    getMe() {
      return this.$api
        .getAPI({
          _action: `/me?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.is_menu_app = res.is_menu_app;
        });
    },

    shouldShowErrorMainForm (storeId) {
      return (this.item && !!this.item.available) && (this.selectedStores.length && this.selectedStores.includes(storeId))
    }
  },

  mounted() {
    this.prev_varinat_map = new Map();
    this.variant_options_map = new Map();
    this.prev_variant_store_map = new Map();
    this.variant_store_map = new Map();
    this.is_enable_b2b = localStorage.getItem('is_enable_b2b', '') == 'true'
    Promise.all([
      this.getSuppliers(),
      this.getStores(),
      this.getAllCategoryList(),
      this.getNextSKU(),
      this.getMe()
    ]).then(res => {
          this.accessRight = JSON.parse(localStorage.getItem('accessright') || '{}')
          if (this.$route.params.id) {
            this.details(this.$route.params.id);
          } else {
            this.getColorList();
          }
        }
    );
  },
  watch: {
    'item.category_id': function (newVal, oldVal) {
      if(newVal){
        this.onChangeCategory({target: {value: newVal}})
      }
    }
  },
}
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <form data-vv-scope="main-form">
        <div class="row">
          <div class="col-lg-8">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="row mb-4">
                  <div class="col-lg-6 mb-lg-0 mb-3">
                    <label for>{{$lang.messages.name}}</label>
                    <span style="color:#ff0000">*</span>
                    <input
                      name="name"
                      v-model="item.name"
                      v-validate="'required|max:300'"
                      class="form-control"
                      maxlength="300"
                      :class="{'input': true, 'is-danger': errors.has('main-form.name') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.name"
                    />
                    <i v-show="errors.has('main-form.name')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.name')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_name}}</span>
                  </div>
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.category}}</label>
                    <select
                      v-model="item.category_id"
                      class="form-control"
                      name="category"
                      @change="onChangeCategory($event)"
                      v-validate="'required'"
                    >
                      <option value>{{$lang.messages.select_category}}</option>
                      <option
                        v-for="category in categories"
                        :key="category.id"
                        :value="category.id"
                      >{{category.name}}</option>
                    </select>

                    <i v-show="errors.has('main-form.category')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.category')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_category}}</span>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-lg-12">
                    <label for>{{$lang.messages.description}}</label>
                    <input
                      name="description"
                      v-model="item.description"
                      v-validate="'max:1000'"
                      class="form-control"
                      maxlength="500"
                      :class="{'input': true}"
                      type="text"
                      v-bind:placeholder="$lang.messages.description"
                    />
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-lg-6 col-6">
                    <label
                      for
                      class="font-18 text-dark"
                    >{{$lang.messages.the_item_is_available_for_now}}</label>
                  </div>
                  <div class="col-lg-6 col-6 text-right">
                    <div class="form-group">
                      <span class="switch switch-sm">
                        <input
                          type="checkbox"
                          class="switch"
                          id="switch-available"
                          v-model="item.available "
                        />
                        <label for="switch-available"></label>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-lg-12">
                    <label class="text-dark mr-3 d-lg-inline d-block">{{$lang.messages.sold_by}}</label>
                    <div class="custom-control custom-radio d-inline-block mr-5">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="customControlValidation3"
                        name="radio-stacked"
                        v-model="item.sold_by"
                        value="EACH"
                        required
                      />
                      <label
                        class="custom-control-label"
                        for="customControlValidation3"
                      >{{$lang.messages.each}}</label>
                    </div>
                    <div class="custom-control custom-radio d-inline-block">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="customControlValidation2"
                        name="radio-stacked"
                        v-model="item.sold_by"
                        value="WEIGHT"
                        required
                      />
                      <label
                        class="custom-control-label"
                        for="customControlValidation2"
                      >{{$lang.messages.weight}}</label>
                    </div>
                  </div>
                </div>

                <div
                  class="row mb-4"
                  v-if="(!item.variants_combinations ||  item.variants_combinations.length < 1)"
                >
                  <div class="col-lg-6 mb-lg-0 mb-3">
                    <label for>{{$lang.messages.price}}</label>

                    <input
                      v-if="!is_menu_app"
                      name="price"
                      v-model="item.price"
                      v-validate="'decimal|min:0'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.price') }"
                      @keyup="onChangeItemPrice($event)"
                      type="text"
                      v-bind:placeholder="$lang.messages.price"
                    />
                    <input
                      v-else
                      name="price"
                      v-model="item.price"
                      v-validate="'required|decimal|min:0'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.price') }"
                      @keyup="onChangeItemPrice($event)"
                      type="text"
                      v-bind:placeholder="$lang.messages.price"
                    />
                    <i v-show="errors.has('main-form.price')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.price')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_price}}</span>
                  </div>
                  <div class="col-lg-6" v-if="item.track_stock && item.composite_item">
                    <label for>{{$lang.messages.average_cost}}</label>

                    <input
                      name="cost"
                      v-model="item.cost"
                      v-validate="'decimal|min:0'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.cost') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.average_cost"
                      @keyup="onChangeItemCost($event)"
                      :disabled=" (item.composite_item ) || ($route.params.id)"
                    />
                    <i v-show="errors.has('main-form.cost')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.cost')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_average_cost}}</span>
                  </div>
                  <div class="col-lg-6" v-else>
                    <label for>{{$lang.messages.cost}}</label>
                    <input
                      name="cost"
                      v-model="item.cost"
                      v-validate="'decimal'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.cost') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.cost"
                      @keyup="onChangeItemCost($event)"
                      :disabled="item_variant_stores.length != $_.filter(item_variant_stores, o => o.cost_editable == true).length"
                    />
                    <i v-show="errors.has('main-form.cost')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.cost')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_cost}}</span>
                  </div>
                </div>
                <div
                  class="row mb-4"
                  v-if="is_enable_b2b && accessRight.edit_b2b_store"
                >
                  <div class="col-lg-6 mb-lg-0 mb-3">
                    <label for>{{$lang.messages.b2b_price}}</label>
                    <input
                      name="b2b_price"
                      v-model="item.b2b_price"
                      v-validate="'decimal|min:0'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.b2b_price') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.b2b_price"
                    />
                    <i v-show="errors.has('main-form.b2b_price')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.b2b_price')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_price}}</span>
                  </div>
                </div>

                <div class="row mb-4">
                  <div class="col-lg-6 col-6">
                    <label for class="font-18 text-dark">{{$lang.messages.sku_and_barcode}}</label>
                  </div>
                  <div class="col-lg-6 col-6 text-right">
                    <div class="form-group">
                      <span class="switch switch-sm">
                        <input
                          type="checkbox"
                          class="switch"
                          id="switch-barcode"
                          v-model="item.is_sku_barcode "
                        />
                        <label for="switch-barcode"></label>
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  class="row"
                  v-if="item.is_sku_barcode && (item.composite_item || (!item.variants_combinations ||  item.variants_combinations.length < 1)) "
                >
                  <div class="col-lg-6 mb-lg-0 mb-3">
                    <label for>{{$lang.messages.sku}}</label>
                    <input
                      name="sku"
                      v-model="item.sku"
                      v-validate="'required'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.sku') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.sku"
                    />
                    <i v-show="errors.has('main-form.sku')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.sku')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_sku}}</span>
                  </div>
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.barcode}}</label>
                    <input
                      name="barcode"
                      v-model="item.barcode"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.barcode') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.barcode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="pink-tape mb-4">
                  <h3 class="font-22 mb-0 font-weight-normal">{{$lang.messages.inventory}}</h3>
                </div>
                <!-- <div class="row border-bottom px-3">
                  <div class="col-lg-6 col-6">
                    <label for class="font-18 text-dark">{{$lang.messages.composite_item}}</label>
                  </div>
                  <div class="col-lg-6 col-6 text-right">
                    <div class="form-group">
                      <span class="switch switch-sm">
                        <input
                          type="checkbox"
                          class="switch"
                          id="switch-sm"
                          v-model="item.composite_item"
                          @change="changeIsCompositeItem($event)"
                        />
                        <label for="switch-sm"></label>
                      </span>
                    </div>
                  </div>
                </div>-->
                <div class="row pt-4 px-3">
                  <div class="col-lg-6 col-6">
                    <label
                      for
                      class="font-18 text-dark"
                    >{{item.composite_item ? $lang.messages.use_production :$lang.messages.track_stock }}</label>
                  </div>
                  <div class="col-lg-6 col-6 text-right">
                    <div class="form-group">
                      <span class="switch switch-sm">
                        <input
                          type="checkbox"
                          class="switch"
                          id="switch-2"
                          v-model="item.track_stock"
                        />
                        <label for="switch-2"></label>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="!item.composite_item && item.track_stock">
                  <div class="col-lg-6 mb-lg-0 mb-3">
                    <label for>{{$lang.messages.primary_supplier}}</label>
                    <multiselect
                      v-model="item.primary_supplier_object"
                      :options="suppliers"
                      :custom-label="setSupplierName"
                      :placeholder="$lang.messages.primary_supplier"
                      label="name"
                      track-by="name"
                      @select="onSupplierSelect"
                      :select-label="$lang.messages.please_enter_to_select"
                      :deselect-label="$lang.messages.please_enter_to_remove"
                      :tag-placeholder="$lang.messages.press_enter_to_create_new_tag"
                      :selected-label="$lang.messages.selected"
                    > <span slot="noOptions">{{$lang.messages.list_is_empty}}</span> </multiselect>
                  </div>
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.default_purchase_cost}}</label>
                    <input
                      name="default_purchase_cost"
                      v-model="item.default_purchase_cost"
                      v-validate="'decimal'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('main-form.default_purchase_cost') }"
                      type="text"
                      v-bind:placeholder="$lang.messages.default_purchase_cost"
                    />

                    <i v-show="errors.has('main-form.default_purchase_cost')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('main-form.default_purchase_cost')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_default_purchase_cost}}</span>
                  </div>
                </div>

                <div class="p-3 border mt-3" v-if="item.composite_item">
                  <table class="table table-striped table-style-1 table-responsive">
                    <thead>
                      <tr>
                        <th scope="col">{{$lang.messages.component}}</th>
                        <th scope="col" width="20%">{{$lang.messages.quantity}}</th>
                        <th scope="col">{{$lang.messages.price}}</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sel, index)  in selected_items" :key="'composite_item_'+index">
                        <td>{{sel.name}}</td>
                        <td width="20%">
                          <input
                            type="text"
                            v-model="sel.quantity"
                            :id="'composite_item_quantity_' + index"
                            :name="'composite_item_quantity_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.composite_item_quantity_' + index) }"
                            v-validate="'decimal'"
                            @blur="calculateCompositeItemPrice(index)"
                          />
                        </td>
                        <td>{{sel.price}}</td>
                        <td>
                          <a href="javascript:void(0)" @click="removeSelectedItem(index)">
                            <i class="far fa-trash-alt font-20 text-danger"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="row" v-if="item.composite_item">
                    <div class="col-lg-12">
                      <div>
                        <label class="typo__label">{{$lang.messages.item_search}}</label>

                        <multiselect
                          v-validate="'required'"
                          v-model="selected_items"
                          :options="item_list"
                          :multiple="true"
                          :class="{'input': true, 'is-danger': errors.has('main-form.searchItem') }"
                          :close-on-select="true"
                          :clear-on-select="false"
                          v-bind:placeholder="$lang.messages.please_select_option"
                          label="name"
                          track-by="name"
                          name="searchItem"
                          :select-label="$lang.messages.please_enter_to_select"
                          :deselect-label="$lang.messages.please_enter_to_remove"
                          :tag-placeholder="$lang.messages.press_enter_to_create_new_tag"
                          :selected-label="$lang.messages.selected"
                        >
                          <span slot="noOptions">{{$lang.messages.list_is_empty}}</span>
                          <template slot="selection">
                            <span class="multiselect__single" v-if="selected_items.length"></span>
                          </template>
                        </multiselect>

                        <i v-show="errors.has('main-form.searchItem')" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('main-form.searchItem')"
                          class="help is-danger"
                        >{{$lang.messages.please_select_atleast_one_item}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-8" v-if="!item.composite_item">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="pink-tape mb-4">
                  <h3 class="font-22 mb-0 font-weight-normal">{{$lang.messages.variants}}</h3>
                </div>
                <div class="row px-3">
                  <div class="col-lg-12 mb-3">
                    <label
                      for
                      class="font-18 text-dark"
                    >{{$lang.messages.use_variants_suggestion_messge}}</label>
                  </div>
                  <div class="col-lg-12">
                    <a
                      href="javascript:void(0)"
                      @click="clearAddVariantModal()"
                      class="text-primary"
                      data-toggle="modal"
                      data-target="#exampleModalCenter"
                    >
                      <i class="fas fa-plus-circle font-18 mr-2"></i>
                      {{$lang.messages.add_variants}}
                    </a>
                  </div>
                </div>

                <table
                  class="table table-striped table-style-1 table-responsive"
                  v-if="item.variants_combinations != null && item.variants_combinations.length > 0"
                >
                  <thead>
                    <tr>
                      <th scope="col">{{$lang.messages.variant}}</th>
                      <th scope="col">{{$lang.messages.price}}</th>
                      <th scope="col">{{$lang.messages.cost}}</th>
                      <th scope="col" v-if="item.track_stock">{{$lang.messages.purchase_cost}}</th>

                      <th
                        scope="col"
                        v-if="item.is_sku_barcode != null && item.is_sku_barcode"
                      >{{$lang.messages.sku}}</th>
                      <th
                        scope="col"
                        v-if="item.is_sku_barcode != null && item.is_sku_barcode"
                      >{{$lang.messages.barcode}}</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(combination, index) in item.variants_combinations"
                      :key="'comb_'+index"
                    >
                      <td>{{combination.name}}</td>
                      <td>
                        <input
                          v-if="!is_menu_app"
                          type="text"
                          v-model="combination.price"
                          :id="'comb_price_' + index"
                          :name="'comb_price_' + index"
                          :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.comb_price_' + index) }"
                          v-validate="'decimal'"
                          @keyup="onChangeVariantPrice($event)"
                        />
                        <input
                          v-else
                          type="text"
                          v-model="combination.price"
                          :id="'comb_price_' + index"
                          :name="'comb_price_' + index"
                          :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.comb_price_' + index) }"
                          v-validate="'required|decimal'"
                          @keyup="onChangeVariantPrice($event)"
                        />
                        <i
                          v-show="errors.has('main-form.comb_price_' + index)"
                          class="fa fa-warning"
                        ></i>
                        <span
                          v-show="errors.has('main-form.comb_price_' + index)"
                          class="help is-danger"
                        >{{$lang.messages.please_enter_valid_price}}</span>
                      </td>
                      <td>
                        <input
                          type="text"
                          v-model="combination.cost"
                          :id="'comb_cost_' + index"
                          :name="'comb_cost_' + index"
                          :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.comb_cost_' + index) }"
                          v-validate="'required|decimal'"
                          @keyup="onChangeVariantCost($event)"
                          :disabled=" combination.cost_saved"
                        />
                      </td>

                      <td v-if="item.track_stock">
                        <input
                          type="text"
                          v-model="combination.purchase_cost"
                          :id="'comb_purchase_cost_' + index"
                          :name="'comb_purchase_cost_' + index"
                          :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.comb_purchase_cost_' + index) }"
                          v-validate="'required|decimal'"
                        />
                      </td>

                      <td v-if="item.is_sku_barcode != null && item.is_sku_barcode">
                        <input
                          type="text"
                          v-model="combination.sku"
                          :id="'comb_sku_' + index"
                          :name="'comb_sku_' + index"
                          v-validate="'required'"
                          :class="{'form-control':true,'input': true, 'is-danger': errors.has('main-form.comb_sku_' + index) }"
                        />
                      </td>
                      <td v-if="item.is_sku_barcode != null && item.is_sku_barcode">
                        <input
                          type="text"
                          v-model="combination.barcode"
                          :id="'comb_barcode_' + index"
                          :name="'comb_barcode_' + index"
                          :class="{'form-control':true, 'input': true}"
                        />
                      </td>
                      <td>
                        <a href="javascript:void(0)" @click="removeItemVariantCombination(index)">
                          <i class="far fa-trash-alt font-20 text-danger"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="pink-tape mb-4">
                  <h3 class="font-22 mb-0 font-weight-normal">{{$lang.messages.stores}}</h3>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="custom-control custom-checkbox mb-3">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-1"
                        v-model="isAll"
                        @change="checkAllStores($event)"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-1"
                      >{{$lang.messages.available_in_all_stores}}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="text-right custom-select-dd d-inline-block mr-3 mr-lg-3 mr-md-1"
                      style="width: 190px;">
                      <treeselect v-model="filteredStore"
                                  :multiple="true"
                                  :placeholder="$lang.messages.search_store"
                                  :limitText="limitStoreText"
                                  :options="stores"
                                  :normalizer="normalizerStore"
                                  :noOptionsText="$lang.messages.no_results_found"
                                  :noResultsText="$lang.messages.no_results_found"
                                  :limit="0">
                      </treeselect>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div
                      class="text-right custom-select-dd d-inline-block mr-3 mr-lg-3 mr-md-1"
                      style="width: 190px;"
                    >
                      <treeselect v-model="filteredVariant"
                                  :multiple="true"
                                  :placeholder="$lang.messages.search_variant"
                                  :limitText="limitVariantText"
                                  :options="item.variants_combinations"
                                  :normalizer="normalizerVariant"
                                  :noOptionsText="$lang.messages.no_results_found"
                                  :noResultsText="$lang.messages.no_results_found"
                                  :limit="0">
                      </treeselect>
                    </div>
                  </div>
                </div>
                <div style="overflow-x: auto;">
                  <table
                    class="table table-striped table-style-1 table-responsive"
                    id="store_table"
                  >
                    <thead>
                      <th scope="col" style="min-width: 120px;">{{$lang.messages.available}}</th>
                      <th scope="col" style="min-width: 120px;">{{$lang.messages.name}}</th>
                      <th
                        scope="col"
                        v-if="item.variants_combinations != null && item.variants_combinations.length > 0"
                      >{{$lang.messages.variant}}</th>
                      <th scope="col" style="min-width: 120px;">{{$lang.messages.price}}</th>
                      <th scope="col" style="min-width: 120px;">{{$lang.messages.cost}}</th>

                      <th
                        v-if="item.track_stock != null && item.track_stock"
                        scope="col"
                        style="min-width: 120px;"
                      >{{$lang.messages.avaliable_stock}}</th>
                      <th
                        v-if="item.track_stock != null && item.track_stock"
                        scope="col"
                        style="min-width: 120px;"
                      >{{$lang.messages.low_stock_level}}</th>

                      <th
                        v-if="item.track_stock != null && item.track_stock"
                        scope="col"
                        style="min-width: 120px;"
                      >{{$lang.messages.optimal_stock}}</th>
                    </thead>
                    <tbody>
                      <template v-for="(store, index) in item_variant_stores">
                        <tr v-if="(filteredStore.length == 0 || (filteredStore.length != 0 && filteredStore.indexOf(store.store_id) != -1)) && (filteredVariant.length == 0 || (filteredVariant.length != 0 && filteredVariant.indexOf(store.value) != -1))"
                            :key="'store_'+index">
                        <td>
                          <div
                            class="custom-control custom-checkbox"
                            v-if="item.variants_combinations != null && item.variants_combinations.length > 0"
                          >
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              :value="store.store_id+'_'+store.value"
                              :id="'store_'  +store.store_id+'_'+ store.value"
                              :name="'store_'  +store.store_id+'_'+ store.value"
                              v-model="selectedStores"
                              @change="checkUncheckStore($event, index)"
                            />
                            <label
                              class="custom-control-label text-dark ml-2"
                              :for="'store_'  +store.store_id+'_'+ store.value"
                            ></label>
                          </div>
                          <div class="custom-control custom-checkbox" v-else>
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              :value="store.store_id"
                              :id="'store_'  +store.store_id"
                              :name="'store_'  +store.store_id"
                              v-model="selectedStores"
                              @change="checkUncheckStore($event, index)"
                            />
                            <label
                              class="custom-control-label text-dark ml-2"
                              :for="'store_'  +store.store_id"
                            ></label>
                          </div>
                        </td>
                        <td class="store_name">{{store.name}}</td>
                        <td
                          v-if="item.variants_combinations != null && item.variants_combinations.length > 0"
                          class="variants_combination_name"
                        >{{store.value}}</td>
                        <td width="25%">

                          <input
                            type="text"
                            v-model="store.price"
                            :id="'store_price_' + index"
                            :name="'store_price_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.store_price_' + index) }"
                            v-validate="{'required':(store.is_available == true), 'decimal': true, 'rules': `${shouldShowErrorMainForm(store.store_id) ? 'required' : ''}`}"
                          />
                          <i
                            v-show="errors.has('main-form.store_price_' + index)"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('main-form.store_price_' + index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_price}}</span>
                        </td>
                        <td width="25%">
                          <input
                            v-if="is_menu_app && item_variant_stores[index].is_available"
                            type="text"
                            v-model="store.cost"
                            :id="'store_cost_' + index"
                            :name="'store_cost_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.store_cost_' + index) }"
                            v-validate="{'required':(store.is_available == true), 'decimal': true, 'rules': `${shouldShowErrorMainForm(store.store_id) ? 'required' : ''}`}"
                            :disabled="!store.cost_editable"
                          />
                          <input
                            v-else
                            type="text"
                            v-model="store.cost"
                            :id="'store_cost_' + index"
                            :name="'store_cost_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.store_cost_' + index) }"
                            v-validate="{'required':(store.is_available == true), 'decimal': true, 'rules': `${shouldShowErrorMainForm(store.store_id) ? 'required' : ''}`}"
                            :disabled="!store.cost_editable"
                          />
                          <i
                            v-show="errors.has('main-form.store_cost_' + index)"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('main-form.store_cost_' + index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_cost}}</span>
                        </td>
                        <td v-if="item.track_stock != null && item.track_stock">
                          <input
                            type="text"
                            v-model="store.in_stock"
                            :id="'store_in_stock_' + index"
                            :name="'store_in_stock_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.store_in_stock_' + index) }"
                            v-validate="{'required':(store.is_available == true), 'decimal': true, 'rules': `${shouldShowErrorMainForm(store.store_id) ? 'required' : ''}`}"
                            :disabled="!store.in_stock_editable"
                          />
                          <span
                            v-show="errors.has('main-form.store_in_stock_' + index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_available_stock}}</span>
                        </td>

                        <td v-if="item.track_stock != null && item.track_stock">
                          <input
                            type="text"
                            v-model="store.low_stock"
                            :id="'store_low_stock_' + index"
                            :name="'store_low_stock_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.store_low_stock_' + index) }"
                            v-validate="{'required':(store.is_available == true), 'decimal': true, 'rules': `${shouldShowErrorMainForm(store.store_id) ? 'required' : ''}`}"
                          />
                          <span
                            v-show="errors.has('main-form.store_low_stock_' + index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_available_stock}}</span>
                        </td>

                        <td v-if="item.track_stock != null && item.track_stock">
                          <input
                            type="text"
                            v-model="store.optimal_stock"
                            :id="'store_optimal_stock_' + index"
                            :name="'store_optimal_stock_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('main-form.store_optimal_stock_' + index) }"
                            v-validate="{'required':(store.is_available == true), 'decimal': true, 'rules': `${shouldShowErrorMainForm(store.store_id) ? 'required' : ''}`}"
                          />
                          <span
                            v-show="errors.has('main-form.store_optimal_stock_' + index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_available_stock}}</span>
                        </td>
                      </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="card rounded-5 p-lg-3 border">
              <div class="card-body form-style">
                <div class="pink-tape mb-4">
                  <h3
                    class="font-22 mb-0 font-weight-normal"
                  >{{$lang.messages.representation_on_pos}}</h3>
                </div>
                <div class="row px-3">
                  <div class="col-lg-12 mb-3 border-bottom">
                    <div class="custom-control custom-radio d-inline-block mb-2">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="ColorShape"
                        name="representation"
                        v-model="item.representation_type"
                        value="COLOR"
                        required
                      />
                      <label
                        class="custom-control-label"
                        for="ColorShape"
                      >{{$lang.messages.color_and_shape}}</label>
                    </div>

                    <div class="color-thumb-wrap mt-4" v-if="item.representation_type == 'COLOR'">
                      <ul class="color-list list-unstyled list-inline" id="SelectColor">
                        <li
                          class="color-thumb"
                          v-for="color in color_list"
                          @click="selectColorCode(color.id)"
                          :id="'color_'  +color.id"
                          :key="color.id"
                          v-bind:style="{ backgroundColor: color.code }"
                        >&nbsp;</li>
                      </ul>
                    </div>

                    <div class="shape-thumb-wrap mt-4" v-if="item.representation_type == 'COLOR'">
                      <ul class="shape-list list-unstyled list-inline" id="SelectShape">
                        <li
                          class="shape-thumb"
                          id="RECTANGLE"
                          @click="selectShape('RECTANGLE', 'RECTANGLE'  )"
                        >
                          <img src="/images/square-shape.svg" alt="Square Shape" width="50" />
                        </li>
                        <li
                          class="shape-thumb"
                          id="CIRCLE"
                          @click="selectShape('CIRCLE', 'CIRCLE'  )"
                        >
                          <img src="/images/circle-shape.svg" alt="Circle Shape" width="55" />
                        </li>
                        <li class="shape-thumb" id="STAR" @click="selectShape('STAR', 'STAR'  )">
                          <img src="/images/sun-shape.svg" alt="Sun Shape" width="55" />
                        </li>
                        <li
                          class="shape-thumb"
                          id="POLYGON"
                          @click="selectShape('POLYGON', 'POLYGON'  )"
                        >
                          <img src="/images/cleft-shape.svg" alt="cleft Shape" width="55" />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-lg-8">
                    <div class="custom-control custom-radio d-inline-block mb-3">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="image"
                        name="representation"
                        v-model="item.representation_type"
                        value="IMAGE"
                        required
                      />
                      <label class="custom-control-label" for="image">{{$lang.messages.image}}</label>
                    </div>

                    <div class v-if="item.representation_type == 'IMAGE'">
                      <div class="mb-2">
                        <img
                          :src="item.representation_image?item.representation_image: '/images/image-placeholder.jpg'"
                          class="img-fluid w-50"
                          alt="image thumb"
                          id="img_hoder_1"
                          width="180"
                        />
                      </div>
                      <button
                        type="button"
                        class="btn px-3 upload-img-merge-btn rounded-8 btn-outline-primary w-50 text-capitalize"
                      >
                        {{$lang.messages.upload_image}}
                        <input
                          type="file"
                          class="btn upload-img"
                          id="AddPhoto"
                          accept="image/*"
                          @change="onChange($event)"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8 text-right">
            <button
              type="button"
              id="save-btn"
              class="btn btn-primary mr-3"
              @click="validateForm('main-form')"
            >{{$lang.messages.save_btn_text}}</button>
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="$router.go(-1)"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </form>
    </div>

    <div
      class="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5 class="modal-title font-22">{{$lang.messages.create_options}}</h5>
            <button
              type="button"
              class="close"
              ref="addVariantCloseBtn"
              data-dismiss="modal"
              aria-label="Close"
              style="display:none"
            ></button>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form data-vv-scope="add-variant-form">
            <div class="modal-body form-style">
              <div class="row mb-4" v-for="(variant, index) in show_variants" :key="'var_' + index">
                <div class="col-lg-5">
                  <label for>{{$lang.messages.option_name}}</label>
                  <input
                    type="text"
                    v-model="variant.name"
                    :id="'varname_' + index"
                    :name="'varname_' + index"
                    v-validate="'required'"
                    v-bind:placeholder="$lang.messages.option_name"
                    :class="{'form-control':true, 'input': true, 'is-danger': errors.has('add-variant-form.varname_' + index) }"
                  />

                  <i v-show="errors.has('add-variant-form.varname_'  +index)" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('add-variant-form.varname_' + index)"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_option_name}}</span>
                </div>
                <div class="col-lg-6">
                  <label for>{{ $lang.messages.value }}</label>
                  <div>
                    <multiselect
                      v-model="variant.options"
                      v-bind:placeholder="$lang.messages.add_option"
                      v-validate="'required'"
                      :id="'option_' + index"
                      :name="'option_' + index"
                      :options="variant.options"
                      :multiple="true"
                      :taggable="true"
                      :showNoResults="false"
                      :close-on-select="false"
                      @tag="addTag"
                      :class="{'input': true, 'is-danger': errors.has('add-variant-form.option_' + index) }"
                      :select-label="$lang.messages.please_enter_to_select"
                      :deselect-label="$lang.messages.please_enter_to_remove"
                      :selected-label="$lang.messages.selected"
                      :tag-placeholder="$lang.messages.press_enter_to_create_new_tag"
                    ><span slot="noOptions">{{$lang.messages.list_is_empty}}</span></multiselect>
                    <i
                      v-show="errors.has('add-variant-form.option_' + index)"
                      class="fa fa-warning"
                    ></i>
                    <span
                      v-show="errors.has('add-variant-form.option_' + index)"
                      class="help is-danger"
                    >{{$lang.messages.please_select_atleast_one_item}}</span>
                  </div>
                </div>

                <div class="col-lg-1" style="text-align: center;">
                  <label for>{{$lang.messages.action}}</label>
                  <a href="javascript:void(0)" class="form-control" @click="removeVariant(index)">
                    <i class="far fa-trash-alt font-20 text-danger"></i>
                  </a>
                </div>
              </div>
              <div class v-if="show_variants.length < 3">
                <a href="javascript:void(0)" class="text-primary" @click="addVariantOption()">
                  <i class="fas fa-plus-circle font-18 mr-2"></i>
                  {{$lang.messages.add_variants}}
                </a>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button
                type="button"
                class="btn btn-primary mr-3"
                @click="validateForm('add-variant-form')"
              >{{$lang.messages.save_btn_text}}</button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-primary"
                id="cancel-btn"
                @click="resetAddVariantModal()"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Alert
      @rightButtonEvent="saveDuplicatedName($event)"
      v-bind:title="$lang.messages.duplicated_item_name"
      ref="duplicatedItemAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="duplicated-name-modal"
    />

    <Alert
      @rightButtonEvent="saveNoneItemStore($event)"
      v-bind:title="$lang.messages.item"
      ref="noneItemStore"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="none-item-store-modal"
    />

  </div>
</template>
